<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Product Search</h2>
            <p class="demo-description">Filter a product catalog in real time using <code>upp-search</code>.</p>

            <div class="demo-section">
    <upp-search
        placeholder="Search products..."
        [kiosk]="false"
        (Changed)="onSearchChanged($event)">
    </upp-search>

    <p class="result-count">{{ filteredProducts.length }} of {{ products.length }} products</p>

    <ion-list class="product-list">
        <ion-item *ngFor="let product of filteredProducts" lines="full">
            <ion-label>
                <h3>{{ product.name }}</h3>
                <p>{{ product.category }}</p>
            </ion-label>
        </ion-item>
        <ion-item *ngIf="filteredProducts.length === 0" lines="none">
            <ion-label color="medium">No products match your search.</ion-label>
        </ion-item>
    </ion-list>
</div>
        </div>
    </upp-scrollable>
</div>
